/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface CourseOption
 */
export interface CourseOption {
    /**
     * 
     * @type {number}
     * @memberof CourseOption
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CourseOption
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CourseOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CourseOption
     */
    nameJa: string;
    /**
     * 
     * @type {number}
     * @memberof CourseOption
     */
    displayOrder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CourseOption
     */
    isOther: boolean;
    /**
     * 
     * @type {Array<Option>}
     * @memberof CourseOption
     */
    programTypes: Array<Option>;
    /**
     * 
     * @type {boolean}
     * @memberof CourseOption
     */
    readonly hidden: boolean;
}

export function CourseOptionFromJSON(json: any): CourseOption {
    return CourseOptionFromJSONTyped(json, false);
}

export function CourseOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourseOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'displayOrder': !exists(json, 'displayOrder') ? undefined : json['displayOrder'],
        'isOther': json['isOther'],
        'programTypes': ((json['programTypes'] as Array<any>).map(OptionFromJSON)),
        'hidden': json['hidden'],
    };
}

export function CourseOptionToJSON(value?: CourseOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'nameJa': value.nameJa,
        'displayOrder': value.displayOrder,
        'isOther': value.isOther,
        'programTypes': ((value.programTypes as Array<any>).map(OptionToJSON)),
    };
}


